import { render, staticRenderFns } from "./SvSelect.vue?vue&type=template&id=59ca7974&scoped=true&lang=pug&"
import script from "./SvSelect.vue?vue&type=script&lang=js&"
export * from "./SvSelect.vue?vue&type=script&lang=js&"
import style0 from "./SvSelect.vue?vue&type=style&index=0&id=59ca7974&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ca7974",
  null
  
)

export default component.exports